import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../contexts/StockCountZonesContext';
import StockCountZonesCreateCategoriesModal from './modals/StockCountZonesCreateCategoriesModal';
import StockCountZonesCreateItemsModal from './modals/StockCountZonesCreateItemsModal';
import StockCountZonesCreateBulkItemsModal from './modals/StockCountZonesCreateBulkItemsModal';
import StockCountZonesDeleteCategoriesModal from './modals/StockCountZonesDeleteCategoriesModal';
import StockCountZonesDeleteItemsModal from './modals/StockCountZonesDeleteItemsModal';
import LeavePageModal from '../../../components/shared/dialogs/LeavePageModal';


const StockCountZonesPopups = () => {
  const { closeSnackBar,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
    blocker,
    isSubmitting,
    handleLeavePageModalClose,
    handleLeavePageModalConfirm } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  return (
    <>
      <StockCountZonesCreateCategoriesModal />
      <StockCountZonesCreateItemsModal />
      <StockCountZonesCreateBulkItemsModal />
      <StockCountZonesDeleteCategoriesModal />
      <StockCountZonesDeleteItemsModal />
      <LeavePageModal open={blocker.state === 'blocked'}
        onConfirm={handleLeavePageModalConfirm}
        onClose={handleLeavePageModalClose}
        onConfirmUrl='/stock-count-schedule/3'
        navigateOnConfirm={false}
        isProcessing={isSubmitting} />
      <MessagesSnackbar onClose={closeSnackBar}
        open={isSnackBarOpen}
        severity={snackBarSeverity}
        message={snackbarMessage}
        duration={snackBarDuration} />
    </>
  );
};

export default StockCountZonesPopups;